var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2201_12734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5524 0.448403C13.4508 0.346788 13.3016 0.309184 13.1639 0.35046L1.21391 3.93549C0.687298 4.09346 0.333496 4.56898 0.333496 5.11895C0.333496 5.66129 0.697689 6.14413 1.2192 6.29314L6.26579 7.73502L7.70766 12.7816C7.85667 13.3031 8.33951 13.6673 8.88206 13.6673C9.43183 13.6673 9.90735 13.3135 10.0653 12.7869L13.6503 0.83684C13.6916 0.69921 13.654 0.550017 13.5524 0.448403ZM1.11475 5.11877C1.11475 4.91666 1.2448 4.74187 1.43839 4.68379L11.9044 1.54398L6.46808 6.98033L1.43381 5.54197C1.24597 5.48827 1.11475 5.31434 1.11475 5.11877ZM9.31704 12.5624C9.25896 12.756 9.08417 12.8861 8.88186 12.8861C8.68647 12.8861 8.51253 12.7549 8.45886 12.567L7.0205 7.53273L12.4569 2.09637L9.31704 12.5624Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2201_12734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 13.3333,
    fill: "white",
    transform: "translate(0.333496 0.333984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.28cf0cd6a35cf5940be216f53097d0db.svg";
export { ForwardRef as ReactComponent };